import _ from 'lodash';
import {
  FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_SHOW,
  FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_HIDE,
  FILE_MAPPING_WIZARD_ADD_FIELD_VALUE_TYPE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_TYPE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_HIDE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_RESET,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_CLEAR,
  FILE_MAPPING_WIZARD_ADD_FIELD_COLUMN_SELECT,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_CURSOR_SET,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_FIELD_PASTE,
  FILE_MAPPING_WIZARD_ADD_FIELD,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CONCAT_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBMIT,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_CLEAR,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_CLEAR,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_CLEAR,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IIF_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CASE_FORM_CHANGE,
  FILE_MAPPING_WIZARD_SELECT_DISTINCT,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_FORM_CHANGE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_HIDE_MODAL,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_UPLOAP_PREVIEW,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_SHOW,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_HIDE,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_CSV_ROWS,
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IMPORT_FILEPATH,
} from './actions';
import { FILE_MAPPING_WIZARD_CALC_FIELD_GET, FILE_MAPPING_WIZARD_DELETE_CALC_FIELD, FILE_MAPPING_WIZARD_DELETE_DEPENDENCY_ERROR_HIDE, FILE_MAPPING_WIZARD_EDIT_CALC_FIELD_SHOW } from '../actions';
import { FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES } from '../import-csv-form/actions';
import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from '../../../../../middlewares/api/actions';
import { checkSubmitableFunction, createExpressionFunctionToArray, createExpressionFunctionToSingle } from '../utils';

export const DOT_STAT_COLUMN_NAME = "_FREQ_";

const fileMappingWizardAddFieldModalReducer = (
  state = {
    addFieldModalVisible: false,
    addFieldModalEditMode: false,
    valueType: '1',
    functionType: null,
    addFieldFunctionWizardVisible: false,
    addFileComponentFunctionWizardVisible:false,
    selectValue: '',
    startValue: 0,
    lenghtValue: 0,
    SubstrFormData: {
      selectValue: '',
      startValue: 0,
      lenghtValue: 0
    },
    ReplaceFormData: {
      selectValue: '',
      replaceValue: '',
      withValue: ''
    },
    TrimFormData: {
      selectValue: '',
      toTrimValue: ''
    },
    PadFormData: {
      selectValue: '',
      patternValue: ''
    },
    ConcatFormData: {
      selectListValue: []
    },
    FunctionFormData: {
      nameValue: '',
      originalName: '',
      functionValue: '',
      cursorStart: 0,
      cursorEnd: 0
    },
    IfFormDataList: [],
    IfFormData:{
      valueY: '',
      valueX: '',
      valueZ: ''
    },
    CaseComponentDefinition:{
      blocks:[],
      componentDefault:''
    },
    FileComponent: {
      file: null,
      separator: ';',
      delimiter: null,
      hasHeader: true,
      componentValue: ''  
    },
    fileServerPath:null,
    fileCsvRows: null,
    fileServerPreviewShow:false,
    CaseFormBlocks:[],
    selectDistinctData:null,
    selectedColumnName: null,
    selectedMapping: null,
    submitable: false,
    fetchNewField: false,
    isDependencyErrorVisible: false,
  },
  action
) => {
  switch (action.type) {
    case FILE_MAPPING_WIZARD_ADD_FIELD_COLUMN_SELECT:
      return {
          ...state,
          selectedColumnName: action.columnName,
          selectedMapping: null,
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_FORM_CHANGE:
      const substrFormData = _.cloneDeep(state.SubstrFormData);
      const substrMergedData = _.merge(substrFormData, action.fields);
      var submitable = false; 
      if(substrMergedData.selectValue !== '' &&
         ((substrMergedData.startValue !== 0 &&
         substrMergedData.lenghtValue !== 0) || 
         (substrMergedData.startValue < 0 &&
          substrMergedData.lenghtValue === 0 ))) {
          submitable = true;
        } else {
          submitable = false;
        }
      return {
        ...state,
        SubstrFormData: substrMergedData,
        submitable: submitable
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_FORM_CHANGE:
      const replaceFormData = _.cloneDeep(state.ReplaceFormData);
      const replaceMergedData = _.merge(replaceFormData, action.fields);
      var submitable = false; 
      if(replaceMergedData.selectValue !== '' &&
         replaceMergedData.replaceValue !== '') {
          submitable = true;
        } else {
          submitable = false;
        }
      return {
        ...state,
        ReplaceFormData: replaceMergedData,
        submitable: submitable
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_FORM_CHANGE:
      const trimFormData = _.cloneDeep(state.TrimFormData);
      const trimMergedData = _.merge(trimFormData, action.fields);
      var submitable = false; 
      if(trimMergedData.selectValue !== '') {
          submitable = true;
        } else {
          submitable = false;
        }
      return {
        ...state,
        TrimFormData: trimMergedData,
        submitable: submitable
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_FORM_CHANGE:
      const padFormData = _.cloneDeep(state.PadFormData);
      const padMergedData = _.merge(padFormData, action.fields);
      var submitable = false; 
      if(padMergedData.selectValue !== '' &&
         padMergedData.patternValue !== '') {
          submitable = true;
        } else {
          submitable = false;
        }
      return {
        ...state,
        PadFormData: padMergedData,
        submitable: submitable
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FORM_CHANGE:
      const functionFormData = _.cloneDeep(state.FunctionFormData);
      return {
        ...state,
        FunctionFormData: _.merge(functionFormData, action.fields)
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CONCAT_FORM_CHANGE:
      return {
        ...state,
        ConcatFormData: {
          selectListValue: action.fields
        },
        submitable: (!action.fields.some(element => element.selectValue === null) && action.fields.length >= 2)
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IIF_FORM_CHANGE:

      let iffComponent = _.cloneDeep(state.IfFormDataList)
      
        if(action.value.blocks){  
            iffComponent = action.value.blocks.map((b, index) => {
              return ({...b, blockIdx: index})
            })
        }else{
          let block = iffComponent[action.value.blockIdx]
          
          if(block){
            if(action.value.componentX !== undefined){
              block.componentX = action.value.componentX
            }
            else if(action.value.componentY !== undefined){
              block.componentY = action.value.componentY
            }
            else if(action.value.componentZ !== undefined){
              block.componentZ = action.value.componentZ
            }
            else if(action.value.conditions){
              block.conditions = action.value.conditions.map((b, index) =>{
                if(index > 0) _.assign(block.conditions[0],{...block.conditions[0], logicalOperator: "" })
                return  ({...b, idx: index}) 
              })
            }else{
              let condition = block.conditions[action.value.idx]
              if(condition){
                  if(action.value.functionName !== undefined){
                    condition.functionName = action.value.functionName
                  }
                  else if(action.value.componentName !== undefined){
                    condition.componentName = action.value.componentName
                    condition.selectDistinct = null
                    condition.operator = ""
                  }
                  else if(action.value.operator !== undefined){
                    condition.operator = action.value.operator
                    condition.selectDistinct = null
                  }
                  else if(action.value.selectDistinct !== undefined){
                    condition.selectDistinct = action.value.selectDistinct
                  }
                  else if(action.value.logicalOperator !== undefined){
                    condition.logicalOperator = action.value.logicalOperator
                  }
                  else if(action.value.values){
                    condition.values = {...condition.values, ...action.value.values  }     
                  }
              }
            }
          }
        }
       
        let check = checkSubmitableFunction(iffComponent,['values'],['conditions'])
        return {
          ...state,
          IfFormDataList: iffComponent,
          submitable: check
        };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CASE_FORM_CHANGE:
    
        let componentDefinition = _.cloneDeep(state.CaseComponentDefinition)
        
        if (action.value.defaultValue !== undefined){
          componentDefinition.componentDefault = action.value.defaultValue
        }
        else if(action.value.blocks){
          componentDefinition.blocks = action.value.blocks.map((b, index) => {
              return ({...b, blockIdx: index})
          });
        }
        else{
          let block = componentDefinition.blocks[action.value.blockIdx];
              if (block) {
                  if (action.value.logicalOperator !== undefined){
                      block.logicalOperator = action.value.logicalOperator
                  }
                  else if(action.value.baseValue !== undefined){
                      componentDefinition.blocks[action.value.blockIdx].baseValue = action.value.baseValue
                  }    
                  else if (action.value.conditions) {
                      block.conditions = action.value.conditions.map((c, index) => {
                          return ({...c, idx: index, logicalOperator: index > 1 ? 'AND' : ''})
                      });
                  }  
                  else{
                    let conditions = block.conditions[action.value.idx];
                    if(conditions){
                      if(action.value.functionName !== undefined){
                        conditions.functionName = action.value.functionName
                      }
                      else if(action.value.componentName !== undefined){
                        conditions.componentName = action.value.componentName
                        conditions.selectDistinct = null
                      }
                      else if(action.value.operator !== undefined){
                        conditions.operator = action.value.operator
                      }
                      else if(action.value.selectDistinct !== undefined){
                        conditions.selectDistinct = action.value.selectDistinct
                      }
                      else if(action.value.values){
                        conditions.values = {...conditions.values, ...action.value.values}
                      }
                    }
                  }
              }
        }
        let checkCase = componentDefinition.blocks.length > 0 && checkSubmitableFunction(componentDefinition,['values'],['blocks','conditions'])
        return {
          ...state,
          CaseComponentDefinition:componentDefinition,
          submitable: checkCase
        }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_FORM_CHANGE:
          return {
            ...state,
            FileComponent: {
              ...state.FileComponent,
              ..._.mapValues(action.fields, field => field.value)
            },
            fileServerPath: null
          }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_HIDE_MODAL:
        return {
          ...state,
          addFileComponentFunctionWizardVisible:false,
          FileComponent: {
            file: null,
            separator: ';',
            delimiter: null,
            hasHeader: true,
            componentValue: ''  
          }
        }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_SHOW:
       return {
        ...state,
        fileServerPreviewShow: true
       }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_HIDE:
      return {
        ...state,
        fileServerPreviewShow: false
       }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_RESET:
      return {
        ...state,
        FunctionFormData: {
          nameValue: state.FunctionFormData.nameValue,
          originalName: state.FunctionFormData.originalName,
          functionValue: '',
          cursorStart: 0,
          cursorEnd: 0
        },
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_SHOW:
      return {
        ...state,
        addFieldModalVisible: true
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_HIDE:
      return {
        ...state,
        addFieldModalVisible: false,
        addFieldModalEditMode: false,
        FunctionFormData: {
          nameValue: '',
          originalName: '',
          functionValue: '',
          cursorStart: 0,
          cursorEnd: 0
        }
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_VALUE_TYPE:
      return {
        ...state,
        valueType: action.valueType,
        FunctionFormData: {
          nameValue: state.FunctionFormData.nameValue,
          originalName: state.FunctionFormData.originalName,
          functionValue: '',
          cursorStart: 0,
          cursorEnd: 0
        },
      };
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_TYPE:
      return {
        ...state,
        functionType: action.functionType,
        addFieldFunctionWizardVisible: !_.includes(action.functionType, 'File'),
        addFileComponentFunctionWizardVisible: _.includes(action.functionType, 'File')
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_HIDE:
      return {
        ...state,
        SubstrFormData: {
          selectValue: '',
          startValue: 0,
          lenghtValue: 0
        },
        ReplaceFormData: {
          selectValue: '',
          replaceValue: '',
          withValue: ''
        },
        TrimFormData: {
          selectValue: '',
          toTrimValue: ''
        },
        PadFormData: {
          selectValue: '',
          patternValue: ''
        },
        ConcatFormData: {
          selectListValue: []
        },
        IfFormDataList: [],
        CaseComponentDefinition:{
          blocks:[],
          componentDefault:''
        },
        addFieldFunctionWizardVisible: false,
        functionType: null,
        submitable: false
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_CLEAR:
      return {
        ...state,
        SubstrFormData: {
          selectValue: '',
          startValue: 0,
          lenghtValue: 0
        },
        submitable: false
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_CLEAR:
      return {
        ...state,
        ReplaceFormData: {
          selectValue: '',
          replaceValue: '',
          withValue: ''
        },
        submitable: false
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_CLEAR:
      return {
        ...state,
        TrimFormData: {
          selectValue: '',
          toTrimValue: ''
        },
        submitable: false
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_CLEAR:
      return {
        ...state,
        PadFormData: {
          selectValue: '',
          patternValue: ''
        },
        submitable: false
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBMIT:
  
      var submitFunction = '';
      switch(action.functionTypeName) {
        case 'Substr':
          if(state.SubstrFormData.startValue < 0 && state.SubstrFormData.lenghtValue === 0) {
            submitFunction = action.functionTypeBase.replace('[X&', `[${state.SubstrFormData.selectValue}]`).replace('[Y&', 1).replace('[Z&', `len([${state.SubstrFormData.selectValue}]) ${state.SubstrFormData.startValue.replace(/'/g, "''")}`);
          } else {
            submitFunction = action.functionTypeBase.replace('[X&', `[${state.SubstrFormData.selectValue}]`).replace('[Y&', state.SubstrFormData.startValue.replace(/'/g, "''")).replace('[Z&', state.SubstrFormData.lenghtValue.replace(/'/g, "''"));
          }
          break;
        case 'Replace':
          submitFunction = action.functionTypeBase.replace('[X&', `[${state.ReplaceFormData.selectValue}]`).replace('[Y&', `'${state.ReplaceFormData.replaceValue.replace(/'/g, "''")}'`).replace('[Z&', `'${state.ReplaceFormData.withValue.replace(/'/g, "''")}'`);
          break;
        case 'Trim':
          if(state.TrimFormData.toTrimValue === '') {
            submitFunction = action.functionTypeBase.replace('[X&', `[${state.TrimFormData.selectValue}]`).replaceAll('[Y&', `''`);
          } else {
            submitFunction = action.functionTypeBase.replace('[X&', `[${state.TrimFormData.selectValue}]`).replaceAll('[Y&', `'${state.TrimFormData.toTrimValue.replace(/'/g, "''")}'`);
          }
          break;
        case 'LTrim':
        case 'RTrim':
          submitFunction = action.functionTypeBase.replace('[X&', `[${state.TrimFormData.selectValue}]`).replace('[Y&', `'${state.TrimFormData.toTrimValue !== '' ?  state.TrimFormData.toTrimValue.replace(/'/g, "''") : ' '}'`);
          break;
        case 'LPad':
        case 'RPad':
          submitFunction = action.functionTypeBase.replace('[X&', `[${state.PadFormData.selectValue}]`).replaceAll('[Y&', `'${state.PadFormData.patternValue.replace(/'/g, "''")}'`);
          break;
        case 'Concat':
          var selectList = state.ConcatFormData.selectListValue;
          for (let i = 0; i < selectList.length; i++) {
            if(i !== selectList.length - 1) {
              submitFunction += `[${selectList[i].selectValue}]` + ` ${action.functionTypeBase} `;
            } else {
              submitFunction += `[${selectList[i].selectValue}]`;
            }
          }
          break;
        case 'IIF':
            const blocksIff = _.cloneDeep(state.IfFormDataList);
     
            const createIffAnnidate = (data) => {
                let Z = ''
                for(let i = 0; i < data.length; i++){
                  if(i > 0) {
                    Z = createIffAnnidate(_.drop(data))
                  }else{
                    Z = data[0].componentZ[0] == '[' && data[0].componentZ[data[0].componentZ.length - 1] == ']' ? `${data[0].componentZ}` : `'${data[0].componentZ}'`
                  }   
                }
                let Y = data[0].componentY[0] == '[' && data[0].componentY[data[0].componentY.length - 1] == ']' ? `${data[0].componentY}` : `'${data[0].componentY}'`
               return action.functionTypeBase
                .replace('[X&',`${createExpressionFunctionToArray(data[0].conditions)}`)
                .replace('[Y&', `${Y}`)
                .replace('[Z&',`${data.length > 1 ? Z : `${Z}`}`)
              }

            submitFunction = createIffAnnidate(blocksIff)
           break;
        case 'Case':
            const blocksCase = _.cloneDeep(state.CaseComponentDefinition)
           
            const createCase = (data) => {
              const {blocks, componentDefault} = data
              let expr = ''
              for(let i = 0; i < blocks.length; i++){
                if(i > 0){
                  let baseValue = blocks[i].baseValue[0] == '[' && blocks[i].baseValue[blocks[i].baseValue.length - 1] == ']' ? blocks[i].baseValue : `'${blocks[i].baseValue}'`
                  expr += ` WHEN ${createExpressionFunctionToArray(blocks[i].conditions, blocks[i].logicalOperator)} THEN ${baseValue}`
                }else{
                  let baseValue = blocks[0].baseValue[0] == '[' && blocks[0].baseValue[blocks[0].baseValue.length - 1] == ']' ? blocks[0].baseValue : `'${blocks[0].baseValue}'`
                  expr = `WHEN ${createExpressionFunctionToArray(blocks[0].conditions, blocks[0].logicalOperator)} THEN ${baseValue}`
                }
              }         
              let componentDefaultValue = componentDefault[0] == '[' && componentDefault[componentDefault.length - 1] == ']' ? componentDefault : `'${componentDefault}'`
              return `${expr} ELSE ${componentDefaultValue} END`
            }
            submitFunction = `CASE ${createCase(blocksCase)}`
            break;
        default:
          break;
      }
       
      return {
        ...state,
        SubstrFormData: {
          selectValue: '',
          startValue: 0,
          lenghtValue: 0
        },
        ReplaceFormData: {
          selectValue: '',
          replaceValue: '',
          withValue: ''
        },
        TrimFormData: {
          selectValue: '',
          toTrimValue: ''
        },
        PadFormData: {
          selectValue: '',
          patternValue: ''
        },
        FunctionFormData: {
          nameValue: state.FunctionFormData.nameValue,
          originalName: state.FunctionFormData.originalName,
          functionValue: state.FunctionFormData.functionValue + submitFunction
        },
        ConcatFormData: {
          selectListValue: []
        },
        IfFormDataList: [],
        CaseComponentDefinition:{
          blocks:[],
          componentDefault:''
        },
        FileComponent: {
          file: null,
          separator: ';',
          delimiter: null,
          hasHeader: true,
          componentValue: ''  
        },
        fileServerPath: null,
        fileCsvRows: null,
        addFieldFunctionWizardVisible: false,
        functionType: null,
        submitable: false
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_CURSOR_SET:
      return {
        ...state,
        FunctionFormData: {
          nameValue: state.FunctionFormData.nameValue,
          originalName: state.FunctionFormData.originalName,
          functionValue: state.FunctionFormData.functionValue,
          cursorStart: action.cursorStart,
          cursorEnd: action.cursorEnd
        },
      }
    case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_FIELD_PASTE:
      const cursorStart = state.FunctionFormData.cursorStart ? state.FunctionFormData.cursorStart : state.FunctionFormData.functionValue.length + 1;
      const cursorEnd = state.FunctionFormData.cursorEnd ? state.FunctionFormData.cursorEnd : state.FunctionFormData.functionValue.length + 1;
      var functionValue = '';
      const cleanValue = state.FunctionFormData.functionValue.slice(0, cursorStart) + state.FunctionFormData.functionValue.slice(cursorEnd);
      if(state.FunctionFormData.functionValue.slice(cursorStart, cursorEnd) !== '' && action.isRightClick === true) {
        const value = state.FunctionFormData.functionValue.slice(cursorStart, cursorEnd);
        functionValue = cleanValue.slice(0, cursorStart) + action.field.replaceAll('[X&', value).replaceAll('[Y&', 'Y').replaceAll('[Z&', 'Z') + cleanValue.slice(cursorStart);
      }
      else {
        functionValue = cleanValue.slice(0, cursorStart) + action.field.replaceAll('[X&', 'X').replaceAll('[Y&', 'Y').replaceAll('[Z&', 'Z') + cleanValue.slice(cursorStart);
      }
      return {
        ...state,
        FunctionFormData: {
          nameValue: state.FunctionFormData.nameValue,
          originalName: state.FunctionFormData.originalName,
          functionValue: functionValue,
          cursorStart: 0,
          cursorEnd: 0
        },
      };
    case FILE_MAPPING_WIZARD_DELETE_DEPENDENCY_ERROR_HIDE:
        return {
          ...state,
          isDependencyErrorVisible: false
        }
    case REQUEST_START:
          switch (action.label) {
          case FILE_MAPPING_WIZARD_SELECT_DISTINCT:
            return {
              ...state
            }
          case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_UPLOAP_PREVIEW:
            return {
              ...state,
              fileServerPath:null
            }
          case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IMPORT_FILEPATH:
            
            return {
              ...state
            }
          default:
            return {...state}
          }
    case REQUEST_ERROR:
        switch (action.label) {
          case FILE_MAPPING_WIZARD_ADD_FIELD:
            return {
              ...state,
            }
          case FILE_MAPPING_WIZARD_SELECT_DISTINCT:
            return {
              ...state,
              selectDistinctData: null
            }
          case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_UPLOAP_PREVIEW:
              return {
                ...state,
                fileServerPath:null
              }
          case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IMPORT_FILEPATH:
              
              return {
                ...state
              }
          default:
            return {
              ...state
            };
        }
    case REQUEST_SUCCESS:
        switch (action.label) {
          case FILE_MAPPING_WIZARD_EDIT_CALC_FIELD_SHOW:
            return {
              ...state,
              addFieldModalVisible: true,
              addFieldModalEditMode: true,
              valueType: action.response.IsFixedValue ? '1' : '2',
              FunctionFormData: {
                nameValue: action.response.ColName,
                originalName: action.response.ColName,
                functionValue: action.response.ExpressionField
              }
            }
          case FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES:
            return {
              ...state,
              fetchNewField: true
            }
          case FILE_MAPPING_WIZARD_DELETE_CALC_FIELD: {
            return {
                ...state,
                fetchNewField: true,
                isDependencyErrorVisible: !action.response
            }
          }
          case FILE_MAPPING_WIZARD_ADD_FIELD:
            return {
              ...state,
              addFieldModalVisible: false,
              addFieldModalEditMode: false,
              fetchNewField: true,
              FunctionFormData: {
                nameValue: '',
                originalName: '',
                functionValue: '',
                cursorStart: 0,
                cursorEnd: 0
              }
            }
          case FILE_MAPPING_WIZARD_CALC_FIELD_GET:
            return {
                ...state,
                fetchNewField: false
            }
          case FILE_MAPPING_WIZARD_SELECT_DISTINCT:
            return {
              ...state,
              selectDistinctData: action.response
            }
          case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_UPLOAP_PREVIEW:
            return {
              ...state,
              fileServerPath: action.response
            }
          case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_CSV_ROWS:
            return {
              ...state,
              fileCsvRows: action.response
            }
          case FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IMPORT_FILEPATH:
            return {
              ...state,
              addFileComponentFunctionWizardVisible: false,
              FunctionFormData: {
                ...state.FunctionFormData,
                functionValue: action.response
              },
              FileComponent: {
                file: null,
                separator: ';',
                delimiter: null,
                hasHeader: true,
                componentValue: ''  
              },
              fileServerPath: null,
            }
          default:
            return {...state};
        }
    default:
      return {...state};
  }
};

export default fileMappingWizardAddFieldModalReducer;
